import React, { Component } from 'react';
import Aux from '../../../hoc/Aux';
import Metronome from '../Metronome/Metronome';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';

class MyTools extends Component {
    render() {
        return <Aux>
            <Card>
                <CardHeader title="Moje narzędzia">
                </CardHeader>
                <CardContent>
                    Znajdziesz tu narzędzia przydatne podczas nauki śpiewu.
                </CardContent>
                <Metronome/>
            </Card>
            
            
        </Aux>

    }
}

export default MyTools; 